import fetch from "lib/fetch";
import type { SurfaceTypeInterface } from "types/reference";

type SurfaceTypeListResponse = { data: Array<SurfaceTypeInterface> };

export const getSurfaceTypesRequest = (languageCode: string) =>
    fetch.get<SurfaceTypeListResponse>(`reference/surface_type/${languageCode}`);
